import { EXTENSIONS_IDENTIFIER } from '@abp/ng.theme.shared/extensions';
import { eTerminalManagementComponents } from '../../enums';
import { Store, Select } from '@ngxs/store';
import { IdentityUserExtensionService } from '../../services/identity-users-extension.service';
import { AppModuleManagement } from '../../models';
import { BindUsers, BindAppModules, GetAppTerminalSettings } from '../../actions/terminal-management.actions'
import { finalize } from 'rxjs/operators';
import { TerminalManagementState } from '../../states/terminal-management.state';
import { Observable } from 'rxjs';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ListService, PagedResultDto, ABP, SessionStateService } from '@abp/ng.core';
import { GetList } from '../../actions/app-module-management.actions';
import { AppModuleManagementState } from '../../states/app-module-management.state';

@Component({
    selector: 'terminal-app-modules-modal',
    template: `
    <abp-modal [(visible)]="isModalVisible" [busy]="isModalBusy">
        <ng-template #abpHeader>
            <h3>{{ 'TerminalManagement::AppModuleManagement' | abpLocalization }}</h3>
        </ng-template>
        <ng-template #abpBody>
            <div id="data-tables-table-filter" class="data-tables-filter">
                <div class="input-group">
                    <input
                    type="search"
                    class="form-control"
                    [placeholder]="'AbpUi::PagerSearch' | abpLocalization"
                    [(ngModel)]="list.filter"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" (click)="list.get()">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
                       
            <ngx-datatable [rows]="appModules$ | async" [count]="appModuleTotalCount$ | async" [list]="list" default>
                    
                <ngx-datatable-column [name]="'AbpIdentity::Actions' | abpLocalization" [maxWidth]="120"
                            [sortable]="false">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <input
                            type="checkbox"
                            [(ngModel)]="checkModules[row.id]"
                        />
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="100" [name]="'TerminalManagement::AppModule:Name' | abpLocalization"
                    prop="name" [sortable]="true">
                </ngx-datatable-column>
                <ngx-datatable-column [width]="100" [name]="'TerminalManagement::AppModule:Code' | abpLocalization"
                    prop="code" [sortable]="true">
                </ngx-datatable-column>
                <ngx-datatable-column [width]="50" [name]="'TerminalManagement::AppModule:Ico' | abpLocalization"
                    prop="ico" [sortable]="true">
                </ngx-datatable-column>
                <ngx-datatable-column [width]="80" [name]="'TerminalManagement::AppModule:Enabled' | abpLocalization"
                    prop="enabled" [sortable]="true">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="row.enabled" class="badge badge-success">是</span>
                        <span *ngIf="!row.enabled" class="badge badge-danger">否</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="80" [name]="'TerminalManagement::AppModule:Visible' | abpLocalization"
                    prop="visible" [sortable]="true">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="row.visible" class="badge badge-success">是</span>
                        <span *ngIf="!row.visible" class="badge badge-danger">否</span>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </ng-template>

        <ng-template #abpFooter>
            <button type="button" class="btn btn-secondary" #abpClose>
            {{ 'AbpIdentity::Cancel' | abpLocalization }}
            </button>
            <abp-button iconClass="fa fa-check" (click)="addModules()">{{
            'AbpIdentity::Save' | abpLocalization
            }}</abp-button>
        </ng-template>
    </abp-modal>
    `,
    providers: [
        ListService,
        {
            provide: EXTENSIONS_IDENTIFIER,
            useValue: eTerminalManagementComponents.TerminalAppModules
        }
    ]
})
export class TerminalAppModulesModalComponent implements OnInit, OnChanges {

    @Select(AppModuleManagementState.appModules)
    appModules$: Observable<AppModuleManagement.AppModuleItem[]>;

    @Select(AppModuleManagementState.appModuleTotalcount)
    appModuleTotalCount$: Observable<number>;

    @Select(TerminalManagementState.appTerminalSettings)
    appTerminalSettings$: Observable<AppModuleManagement.AppTerminalSettingItem>;

    @Input() checkModules: ABP.Dictionary<boolean> = {};
    @Input() tenant: ABP.BasicItem;
    terminalId: string;

    isModalVisible: boolean = false;
    isModalBusy: boolean = false;

    constructor(
        public readonly list: ListService,
        private store: Store
    ) {

    }

    ngOnInit(): void {
        this.appTerminalSettings$.subscribe(appsettings => {
            if (!appsettings) return;

            this.checkModules = {};
            appsettings.allowModules.filter(x => !!x).map(x => x.id).forEach(x => {
                this.checkModules[x] = true;
            });
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (const key in changes) {
            if (Object.prototype.hasOwnProperty.call(changes, key)) {
                const element = changes[key];
                if (key === 'tenant' && element) {
                    this.hookToQuery();
                }
            }
        }
    }

    addModules() {
        let modules = [];
        for (const key in this.checkModules) {
            if (Object.prototype.hasOwnProperty.call(this.checkModules, key)) {
                modules.push(key);
            }
        }

        this.store.dispatch(new BindAppModules({
            terminalId: this.terminalId,
            modules
        })).pipe(finalize(() => {
            this.isModalBusy = false;
            this.isModalVisible = false;
        })).subscribe();
    }

    private hookToQuery() {

        this.list.hookToQuery(query => {
            return this.store.dispatch(new GetList(query))
        }).subscribe(() => {

        });
    }

    show(terminalId: string) {
        this.isModalVisible = true;
        this.terminalId = terminalId;
        this.getTerminallSetting();
    }

    getTerminallSetting() {
        this.store.dispatch(new GetAppTerminalSettings(this.terminalId)).subscribe();
    }

}